import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import AuthState from "../../AuthState";
import callEach from "../../utilities/callEach";
import { getuserdetails, userlogin, userlogout } from "./api/emcm";
import { cart } from "../api/estore";
import openHiddenIframe from "./utilities/openHiddenIframe";
var defaultState = {
  authState: AuthState.UNKNOWN,
  itemsInCart: 0,
  userName: null,
  userFirstName: null
};

var EMCMLoginService = /*#__PURE__*/function () {
  function EMCMLoginService(config) {
    _classCallCheck(this, EMCMLoginService);

    this.onChangeCallbacks = [];
    this.state = _objectSpread({}, defaultState);
    this.config = config;
  }
  /**
   * Login with JWT. Send a request to EMCM, using valid JWT from ID Service,
   * providing a transferToken to then login to legacy Tax site and eStore if
   * federate is true.
   */


  _createClass(EMCMLoginService, [{
    key: "loginWithJWT",
    value: function () {
      var _loginWithJWT = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(jwt, federate) {
        var userLoginResponse, transferToken, promises;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return userlogin(this.config.emcm.location, this.config.emcm.cors, jwt);

              case 2:
                userLoginResponse = _context.sent;
                transferToken = userLoginResponse.transferToken;

                if (!federate) {
                  _context.next = 7;
                  break;
                }

                promises = this.config.transferIframeLocations.map(function (url) {
                  return openHiddenIframe("".concat(url).concat(transferToken));
                });
                return _context.abrupt("return", Promise.all(promises));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loginWithJWT(_x, _x2) {
        return _loginWithJWT.apply(this, arguments);
      }

      return loginWithJWT;
    }()
    /**
     * Redirect to OnePass with the provided transfer token.
     */

  }, {
    key: "loginWithTransferToken",
    value: function loginWithTransferToken(transferToken) {
      var transferUrl = this.config.onepass.transferUrl;
      var transferTokenParam = "transferToken=".concat(encodeURIComponent(transferToken));
      window.location.replace("".concat(transferUrl).concat(transferUrl.includes("?") ? "&" : "?").concat(transferTokenParam));
    }
    /**
     * Pop the redirect URL from session storage, if one was set. `null` otherwise.
     */

  }, {
    key: "popLoginRedirectURL",
    value: function popLoginRedirectURL() {
      var redirectUrl = sessionStorage.getItem(this.config.redirectUrlSessionKey);

      if (!redirectUrl) {
        return null;
      }

      sessionStorage.removeItem(this.config.redirectUrlSessionKey);
      return redirectUrl;
    }
    /**
     * EMCM Log out. Send a request to EMCM, and when it completes, reset this
     * instance to its default state and trigger a change.
     */

  }, {
    key: "emcmLogout",
    value: function () {
      var _emcmLogout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return userlogout(this.config.emcm.location, this.config.emcm.cors);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function emcmLogout() {
        return _emcmLogout.apply(this, arguments);
      }

      return emcmLogout;
    }()
    /**
     * Initialize the object. Make calls to servers, and update the state based on responses.
     */

  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchUserDetails();

              case 2:
                if (!(this.state.authState === AuthState.LOGGED_IN)) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.fetchCartDetails();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function activate() {
        return _activate.apply(this, arguments);
      }

      return activate;
    }()
    /**
     * Fetch user details. Send a request to EMCM, to retrieve user details from
     * httpOnly cookie.
     */

  }, {
    key: "fetchUserDetails",
    value: function () {
      var _fetchUserDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var userDetails;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return getuserdetails(this.config.emcm.location, this.config.emcm.cors);

              case 3:
                userDetails = _context4.sent;

                if (userDetails.loggedIn) {
                  this.state.authState = AuthState.LOGGED_IN;
                  this.state.userName = userDetails.userName;
                  this.state.userFirstName = userDetails.firstName;
                } else {
                  this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                    authState: AuthState.LOGGED_OUT
                  });
                }

                _context4.next = 11;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);
                this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                  authState: AuthState.LOGGED_OUT
                });
                throw _context4.t0;

              case 11:
                _context4.prev = 11;
                this.privateTriggerChange();
                return _context4.finish(11);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 7, 11, 14]]);
      }));

      function fetchUserDetails() {
        return _fetchUserDetails.apply(this, arguments);
      }

      return fetchUserDetails;
    }()
    /**
     * Fetch cart details. Send a request to eStore, to retrieve current shopping
     * cart item count.
     */

  }, {
    key: "fetchCartDetails",
    value: function () {
      var _fetchCartDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var cartDetails;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return cart(this.config.estore.location);

              case 2:
                cartDetails = _context5.sent;
                this.state.itemsInCart = cartDetails.itemsInCart;
                this.privateTriggerChange();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function fetchCartDetails() {
        return _fetchCartDetails.apply(this, arguments);
      }

      return fetchCartDetails;
    }()
    /**
     * Trigger the login procedure. Likely, redirect to a OnePass login screen.
     */

  }, {
    key: "login",
    value: function login() {
      sessionStorage.setItem(this.config.redirectUrlSessionKey, window.location.href);
      window.location.replace(this.config.identityService.loginUrl);
    }
    /**
     * Logout. Call federatedLogout and logout of Hybris and Wordpress sites also.
     */

  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var promises;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.emcmLogout();

              case 2:
                promises = this.config.signoutIframeLocations.map(function (url) {
                  return openHiddenIframe(url);
                });
                _context6.next = 5;
                return Promise.all(promises);

              case 5:
                this.state = _objectSpread(_objectSpread({}, defaultState), {}, {
                  authState: AuthState.LOGGED_OUT
                });
                this.privateTriggerChange();

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);
        return true;
      }

      return false;
    }
  }, {
    key: "privateTriggerChange",
    value: function privateTriggerChange() {
      callEach(this.onChangeCallbacks, this);
    }
  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.config.site.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.state.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.config.estore.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.state.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.config.emcm.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.config.emcm.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.state.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.state.userFirstName;
    }
  }]);

  return EMCMLoginService;
}();

export { EMCMLoginService as default };